import React from "react"

import { useBounceGlobalValues, useTranslation } from "@bounce/i18n"

import { Hero } from "./components/Hero/Hero"
import { FAQs } from "../../../components/Partner/FAQs/FAQs"
import { Layout } from "../../../components/Partner/Layout/Layout"
import { SignupBanner } from "../../../components/Partner/SignupBanner/SignupBanner"
import { WhyBecomePartner } from "../../../components/Partner/WhyBecomePartner/WhyBecomePartner"
import { useUrl } from "../../../libs/router"

const PartnerScreen = () => {
  const bounceGlobals = useBounceGlobalValues()
  const [t] = useTranslation("marketing-partner")
  const { absolutePath } = useUrl()

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: t("page.partner.metaTitleV4", "Bounce - Partners | Luggage Storage in {{numCities}}+ Cities", {
          numCities: bounceGlobals.numCities,
        }),
        description: t(
          "page.partner.metaDescription",
          "Partner with Bounce to add a new revenue stream to your storefront. It’s free to join and easy to do.",
        ),
      }}>
      <Hero className="!min-h-fit" />
      <WhyBecomePartner className="mt-section" />
      <SignupBanner />
      <FAQs className="mt-section mb-section" />
    </Layout>
  )
}

export default PartnerScreen
